<dx-chart
  *ngIf="show"
  id="totalspendscharts"
  [dataSource]="dataSource"
  [size]="size"
  #totalspendscharts
>
  <dxo-title [text]="title" horizontalAlignment="center">
    <dxo-subtitle [text]="subtitle"></dxo-subtitle>
  </dxo-title>

  <dxi-series
    argumentField="account_type"
    valueField="value"
    name="Current Item"
  ></dxi-series>
  <dxi-series
    argumentField="account_type"
    valueField="new_value"
    name="New Item"
  ></dxi-series>
  <dxo-common-series-settings
    argumentField="state"
    type="bar"
    hoverMode="allArgumentPoints"
    selectionMode="allArgumentPoints"
  >
    <dxo-label [visible]="true" format="currency"></dxo-label>
  </dxo-common-series-settings>
  <dxo-legend verticalAlignment="top" horizontalAlignment="center"></dxo-legend>
  <dxo-export [enabled]="true"></dxo-export>
</dx-chart>

<div
  *ngIf="show && !dataSource"
  class="m-auto"
  style="
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  "
>
  <div class="border rounded shadow" style="width: 200px; height: 100px">
    <dx-load-indicator
      id="large-indicator"
      height="60"
      width="60"
    ></dx-load-indicator>
    <div>Waiting for data...</div>
  </div>
</div>
